module.exports = __webpack_public_path__ + "assets/media/day9.75cb0edd.mp3";